import styled from 'styled-components'
import DefaultTooltip from 'components/Common/Tooltips/DefaultTooltip'
import { useTranslation } from 'react-i18next'

const Wrapper = styled.div`
  appearance: none;
  border: none;
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  position: relative;
  height: 24px;
  width: 24px;
  cursor: pointer;

  :hover {
    background: rgba(18, 20, 50, 0.24);
    border-radius: 4px;
  }
`
const InputWrapper = styled.div``
const Svg = styled.svg`
  pointer-events: auto;
`
const ClearButton = props => {
  const { t } = useTranslation()

  return (
    <Wrapper {...props}>
      <DefaultTooltip
        tooltip={t('review.action.delete')}
        placement='top'
        component={InputWrapper}
        offset={12}
      >
        <Svg
          xmlns='http://www.w3.org/2000/svg'
          width='16'
          height='16'
          viewBox='0 0 16 16'
          fill='none'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M2.33317 3.33268C2.33317 2.96449 2.63165 2.66602 2.99984 2.66602H12.9998C13.368 2.66602 13.6665 2.96449 13.6665 3.33268V14.666C13.6665 15.0342 13.368 15.3327 12.9998 15.3327H2.99984C2.63165 15.3327 2.33317 15.0342 2.33317 14.666V3.33268ZM3.6665 3.99935V13.9993H12.3332V3.99935H3.6665Z'
            fill='white'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M6.6665 5.99935C7.03469 5.99935 7.33317 6.29783 7.33317 6.66602V10.9993C7.33317 11.3675 7.03469 11.666 6.6665 11.666C6.29831 11.666 5.99984 11.3675 5.99984 10.9993V6.66602C5.99984 6.29783 6.29831 5.99935 6.6665 5.99935Z'
            fill='white'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M9.33317 5.99935C9.70136 5.99935 9.99984 6.29783 9.99984 6.66602V10.9993C9.99984 11.3675 9.70136 11.666 9.33317 11.666C8.96498 11.666 8.6665 11.3675 8.6665 10.9993V6.66602C8.6665 6.29783 8.96498 5.99935 9.33317 5.99935Z'
            fill='white'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M0.666504 3.33268C0.666504 2.96449 0.964981 2.66602 1.33317 2.66602H14.6665C15.0347 2.66602 15.3332 2.96449 15.3332 3.33268C15.3332 3.70087 15.0347 3.99935 14.6665 3.99935H1.33317C0.964981 3.99935 0.666504 3.70087 0.666504 3.33268Z'
            fill='white'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M5.84491 1.01223C5.96194 0.798734 6.18604 0.666016 6.4295 0.666016H9.5922C9.8377 0.666016 10.0633 0.800941 10.1795 1.01721L11.2538 3.01721C11.3648 3.22382 11.359 3.47355 11.2387 3.67483C11.1183 3.87612 10.901 3.99935 10.6665 3.99935H5.33317C5.09763 3.99935 4.87957 3.87506 4.75955 3.67239C4.63953 3.46973 4.63535 3.21877 4.74857 3.01223L5.84491 1.01223ZM6.82432 1.99935L6.45887 2.66602H9.55165L9.19355 1.99935H6.82432Z'
            fill='white'
          />
        </Svg>
      </DefaultTooltip>
    </Wrapper>
  )
}

export default ClearButton
